export enum EObstetricWheelDateOption {
	DDR = "ddr",
	DDG = "ddg",
	TERM = "term",
}
